import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as _ from 'lodash';
import { Button, ButtonContainer, Checkbox, Link, Typography } from '@emburse/ui-core';
import { DatePickerEmbark } from '@ReactComponents/Shared/DatePicker/DatePickerEmbark';
import { FULLMONTHNAME_DAY_YEAR } from '@Shared/constants';
import { formatDate } from '@Shared/helpers/abacusTimeFormatter';
// Styles
import 'react-dates/lib/css/_datepicker.css';
import * as style from './BulkSkipPanel.styl';
export class BulkSkipPanel extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            selectedCardMap: {},
            focused: false,
            confirmation: false
        };
    }
    renderEmbarkCardOptions(cards, usersByCardId) {
        return cards.map((card, index) => {
            const user = usersByCardId[card.map_id];
            return (_jsxs("div", { children: [_jsxs("div", Object.assign({ className: "flex ai-c" }, { children: [_jsx(Checkbox, { id: `bulkSkip_${card.id}`, color: "primary", onChange: () => this.toggleSelection(card.map_id), checked: this.state.selectedCardMap[card.map_id] }, this.state.selectedCardMap[card.map_id]), _jsx("label", Object.assign({ htmlFor: `bulkSkip_${card.id}` }, { children: _jsx("strong", { children: card.name }) }))] })), user && _jsx("span", Object.assign({ className: "assignee-user" }, { children: user.name }))] }, index));
        });
    }
    toggleSelection(cardId) {
        const selectedCardMap = _.assign({}, this.state.selectedCardMap);
        selectedCardMap[cardId] = !selectedCardMap[cardId];
        this.setState({ selectedCardMap });
    }
    selectAll(cards) {
        const allSelected = cards.reduce((selectedCardMap, card) => {
            selectedCardMap[card.map_id] = true;
            return selectedCardMap;
        }, {});
        this.setState({ selectedCardMap: allSelected });
    }
    onSave(beforeDate, selectedCardMap) {
        const accountIds = Object.keys(selectedCardMap).filter((cardId) => selectedCardMap[cardId]);
        if (beforeDate && accountIds.length) {
            if (this.state.confirmation) {
                return this.props.onBulkSkipConfirmed(beforeDate, accountIds);
            }
            // If there were errors from previous actions, OK to clear them now.
            this.props.onError(null);
            return this.setState({
                confirmation: true,
                beforeDateFormatted: formatDate(beforeDate, FULLMONTHNAME_DAY_YEAR),
                numAccountIds: accountIds.length
            });
        }
        return this.props.onError('Please select a date and one or more cards.');
    }
    renderEmbarkPanel(cards, usersByCardId) {
        if (this.state.confirmation) {
            return (_jsx("div", { children: _jsxs(Typography, Object.assign({ className: "card-body" }, { children: ["Are you sure you want to skip transactions for these ", this.state.numAccountIds, " card(s) through ", this.state.beforeDateFormatted, "? Careful! This cannot be undone."] })) }));
        }
        return (_jsxs("div", Object.assign({ className: "card-body" }, { children: [_jsxs("div", Object.assign({ className: "date-input" }, { children: [_jsx("p", { children: "Skip all transactions through date" }), _jsx("div", Object.assign({ className: "dateInputContainer embark-modal-date-picker" }, { children: _jsx("div", Object.assign({ className: "inputWrapper" }, { children: _jsx(DatePickerEmbark, { id: "null", label: "Deactivation Date", value: this.state.beforeDate, onChange: (date) => this.setState({ beforeDate: date }), showClearDate: true, disableFuture: true, closeOnSelect: true }) })) }))] })), _jsxs("div", Object.assign({ className: "select-cards" }, { children: [_jsxs("p", { children: ["For selected cards ( ", _jsx(Link, Object.assign({ onClick: () => this.selectAll(cards) }, { children: "Select all" })), " )"] }), _jsx("ul", Object.assign({ className: "listNoBullets bulk-skip-card-list" }, { children: this.renderEmbarkCardOptions(cards, usersByCardId) }))] }))] })));
    }
    renderEmbarkFooter(onCancel) {
        return (_jsxs(ButtonContainer, Object.assign({ alignButtons: "right", className: "card-footer" }, { children: [_jsx(Button, Object.assign({ variant: "outlined", onClick: () => onCancel() }, { children: "Cancel" })), _jsx(Button, Object.assign({ onClick: () => this.onSave(this.state.beforeDate, this.state.selectedCardMap) }, { children: this.state.confirmation ? 'Apply' : 'Save' }))] })));
    }
    render() {
        const { cards, usersByCardId, onCancel } = this.props;
        return cards.length ? (_jsxs("div", Object.assign({ className: style.global }, { children: [this.renderEmbarkPanel(cards, usersByCardId), this.renderEmbarkFooter(onCancel)] }))) : (_jsx("p", { children: "You have no active cards as part of this card program." }));
    }
}
